<div class="layout-wrapper layout-theme-light layout-static p-input-filled flex flex-column h-screen" [ngClass]="containerClass">
  <app-topbar class="layout-topbar"></app-topbar>
  <div class="layout-content-wrap align-items-stretch flex flex-column flex-grow-1">
    <ng-content class="flex-grow-1"></ng-content>
  </div>
</div>
